import BaseModel from "@/models/BaseModel.js";

export default class SchoolFileAsset extends BaseModel {
  fields =  {
    'file_description' : {
      label: 'Deskripsi File',
      type: 'text',
      rules: null
    },
    'file_path' : {
      label: 'File Lampiran (pdf)',
      type: 'attachment',
      rules: 'required'
    },
    'tag': {
      label: 'Kategori File',
      type: 'enum',
      rules: 'required',
      options: {
        'kwitansi': 'Bukti Kwitansi',
        'pajak': 'Bukti Pajak',
      }
    }
  }

  endpoint = process.env.VUE_APP_API_URL + 'school-file-assets';
}
